import React, {FC} from "react"

import {Deal} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import {H3, Label} from "@irati/ui/src/Typography"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"

interface Props {
  deal: Deal
}

const FlexiRewardPrice: FC<Props> = ({deal}) => {
  const productsCount = deal.productConfig?.products.length || 0
  return (
    <Flex direction="column" alignItems="flex-end">
      {productsCount > 1
        ? <Label><FormattedMessage id="perks.deal.savings.label.from" /></Label>
        : <Label><FormattedMessage id="perks.deal.savings.label.price" /></Label>
      }
      <H3>
        <FormattedCurrency
          isCents={false}
          value={deal.productConfig?.products[0]?.salePrice?.value}
          currency={deal.productConfig?.products[0]?.salePrice?.currency} />
      </H3>
    </Flex>
  )
}

export default FlexiRewardPrice
